module.exports = __webpack_public_path__ + "img/cart-check-fill.b40b3d2e.svg";